// src/videos/videos.data.js

// Категории (ключи должны совпадать с category в видео)
export const CATEGORIES = [
  { k: 'metal',    title: 'Металлообробка' },
  { k: 'mebli',    title: 'Меблі' },
  { k: 'hpl',      title: 'HPL-панелі' },
  { k: 'cctv',     title: 'Відеоспостереження' },
  { k: 'acs',      title: 'Контроль доступу' },
  { k: 'gates',    title: 'Ворота та автоматика' },
  { k: 'electro',  title: 'Електромонтаж' },
  { k: 'water',    title: 'Водопостачання та опалення' },
  { k: 'k1k2',     title: 'К1/К2 димовидалення' },
  { k: 'vent',     title: 'Вентиляція' },
  { k: 'core',     title: 'Алмазне свердління' },
];

// ===== Helpers =====
function toId(input) {
  // Принимает "youtu.be/xxx", "watch?v=xxx", "embed/xxx", или чистый ID
  if (!input) return '';
  const str = String(input).trim();
  const directId = /^[\w-]{11}$/.test(str) ? str : null;
  if (directId) return directId;

  try {
    const u = new URL(str);
    if (u.hostname.includes('youtu.be')) return u.pathname.replace('/', '');
    if (u.searchParams.get('v')) return u.searchParams.get('v');
    const m = u.pathname.match(/\/embed\/([\w-]{11})/);
    if (m) return m[1];
  } catch(e) {
    // not a URL, ignore
  }
  return '';
}

function v({ urlOrId, title, category, tags=[] }) {
  const youtubeId = toId(urlOrId);
  return { id: `${category}-${youtubeId||Math.random().toString(36).slice(2,8)}`, youtubeId, title, category, tags };
}

// ====== ВИДЕО ======
// ВАЖНО: НУЖНО 136 штук. Сейчас стоят демо-ролики YouTube (повторяться не должны для продакшена).
// Замени urlOrId на реальные ссылки/ID по категориям (минимум 15 видео в каждой ключевой категории).
export const VIDEOS = [
  // ——— Металлообработка ———
  v({ urlOrId:'https://www.youtube.com/watch?v=M7lc1UVf-VE', title:'Токарна обробка валів — огляд', category:'metal', tags:['токарні','вали','CNC'] }),
  v({ urlOrId:'https://youtu.be/ysz5S6PUM-U',                 title:'Фрезерування корпусних деталей', category:'metal', tags:['фрезерування','3-ось'] }),
  v({ urlOrId:'https://www.youtube.com/embed/aqz-KE-bpKQ',    title:'Зварювання великих вузлів',      category:'metal', tags:['зварювання','сталеві конструкції'] }),

  // ——— Меблі ———
  v({ urlOrId:'M7lc1UVf-VE', title:'Виготовлення каркасу та фасадів', category:'mebli', tags:['меблі','каркас'] }),
  v({ urlOrId:'ysz5S6PUM-U', title:'Збірка шаф та столів',             category:'mebli', tags:['складання','фурнітура'] }),
  v({ urlOrId:'aqz-KE-bpKQ', title:'Фінішне оздоблення',               category:'mebli', tags:['лак','обробка'] }),

  // ——— HPL ———
  v({ urlOrId:'M7lc1UVf-VE', title:'HPL фасади та стільниці', category:'hpl', tags:['HPL','кухні'] }),
  v({ urlOrId:'ysz5S6PUM-U', title:'Обрізка та кромкування HPL', category:'hpl', tags:['HPL','кромка'] }),
  v({ urlOrId:'aqz-KE-bpKQ', title:'Монтаж HPL панелей', category:'hpl', tags:['монтаж'] }),

  // ——— CCTV ———
  v({ urlOrId:'M7lc1UVf-VE', title:'Проєкт 64+ камер: огляд', category:'cctv', tags:['CCTV','NVR','IP'] }),
  v({ urlOrId:'ysz5S6PUM-U', title:'Налаштування відеоаналітики', category:'cctv', tags:['ANPR','периметр'] }),
  v({ urlOrId:'aqz-KE-bpKQ', title:'PoE та резервування живлення', category:'cctv', tags:['PoE','UPS'] }),

  // ——— ACS ———
  v({ urlOrId:'M7lc1UVf-VE', title:'СКУД для складу: турнікети', category:'acs', tags:['СКУД','турнікети'] }),
  v({ urlOrId:'ysz5S6PUM-U', title:'Картки, брелоки, мобільний доступ', category:'acs', tags:['RFID','BLE'] }),
  v({ urlOrId:'aqz-KE-bpKQ', title:'Інтеграція з відео та пожежною', category:'acs', tags:['інтеграція'] }),

  // ——— Gates ———
  v({ urlOrId:'M7lc1UVf-VE', title:'Відкатні ворота та автоматика', category:'gates', tags:['ворота','автоматика'] }),
  v({ urlOrId:'ysz5S6PUM-U', title:'Шлагбауми та паркувальні системи', category:'gates', tags:['паркінг'] }),
  v({ urlOrId:'aqz-KE-bpKQ', title:'Сервіс та регламентні роботи', category:'gates', tags:['сервіс'] }),

  // ——— Electro ———
  v({ urlOrId:'M7lc1UVf-VE', title:'Щитові та силові мережі', category:'electro', tags:['електрощити','PUE'] }),
  v({ urlOrId:'ysz5S6PUM-U', title:'Освітлення виробничих зон', category:'electro', tags:['LED','проект'] }),
  v({ urlOrId:'aqz-KE-bpKQ', title:'Кабельні траси та заземлення', category:'electro', tags:['кабель','PE'] }),

  // ——— Water/Heating ———
  v({ urlOrId:'M7lc1UVf-VE', title:'Опалення складів і офісів', category:'water', tags:['опалення','котельня'] }),
  v({ urlOrId:'ysz5S6PUM-U', title:'Водопостачання та насоси', category:'water', tags:['насоси','водопровід'] }),
  v({ urlOrId:'aqz-KE-bpKQ', title:'Тепла підлога та автоматика', category:'water', tags:['тепла підлога'] }),

  // ——— K1/K2 ———
  v({ urlOrId:'M7lc1UVf-VE', title:'Системи димовидалення К1/К2', category:'k1k2', tags:['димовидалення'] }),
  v({ urlOrId:'ysz5S6PUM-U', title:'Вогнезахист та датчики', category:'k1k2', tags:['пожежна'] }),
  v({ urlOrId:'aqz-KE-bpKQ', title:'Інтеграція з BMS', category:'k1k2', tags:['BMS'] }),

  // ——— Vent ———
  v({ urlOrId:'M7lc1UVf-VE', title:'Вентиляція цехів', category:'vent', tags:['вентиляція','приток/витяжка'] }),
  v({ urlOrId:'ysz5S6PUM-U', title:'Рекуперація та фільтрація', category:'vent', tags:['рекуператор'] }),
  v({ urlOrId:'aqz-KE-bpKQ', title:'Паспортизація систем', category:'vent', tags:['пусконалагодження'] }),

  // ——— Core drilling ———
  v({ urlOrId:'M7lc1UVf-VE', title:'Алмазне свердління отворів', category:'core', tags:['алмазне','отвори'] }),
  v({ urlOrId:'ysz5S6PUM-U', title:'Різання прорізів', category:'core', tags:['різання'] }),
  v({ urlOrId:'aqz-KE-bpKQ', title:'Пиловидалення та безпека', category:'core', tags:['безпека'] }),
];

// ==== ПОДСКАЗКА ====
// Чтобы довести список до 136 шт: просто допиши сюда нужные объекты v({...})
// Можно быстро вставить из таблицы: на вход urlOrId подходит любая YT-ссылка или чистый ID.
